import { render, staticRenderFns } from "./ProdDiv.vue?vue&type=template&id=3b868b53&scoped=true&"
import script from "./ProdDiv.vue?vue&type=script&lang=js&"
export * from "./ProdDiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b868b53",
  null
  
)

export default component.exports